import { number, object, string } from "yup";

export const unitValidations = object({
  title: string().required("Unit name is required"),
  monthly_rent_amount: object({
    cents: number().required(),
    currency: string().required()
  })
    .test("minimum", "Monthly rent must be at least $1", function (value) {
      return value.cents >= 100;
    })
    .test("maximum", "Monthly rent must be $50,000 or less", function (value) {
      return value.cents <= 5000000;
    })
});

export const unitMAValidations = object({
  title: string().required("Unit name is required"),
  home_rent_amount: object({
    cents: number().required(),
    currency: string().required()
  })
    .test("minimum", "Home rent must be at least $0", function (value) {
      return value.cents >= 0;
    })
    .test("maximum", "Home rent must be $50,000 or less", function (value) {
      return value.cents <= 5000000;
    }),
  site_rent_amount: object({
    cents: number().required(),
    currency: string().required()
  })
    .test("minimum", "Site rent must be at least $0", function (value) {
      return value.cents >= 0;
    })
    .test("maximum", "Site rent must be $50,000 or less", function (value) {
      return value.cents <= 5000000;
    })
});
